/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  Panel,
  Col,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import ControlTips from 'loracoms/ControlTips';
import SelectPills from 'loracoms/SelectPills';
import RichButton from 'loracoms/RichButton';
import ShowIf from 'loracoms/ShowIf';
import ErrorSet from 'lorautils/errors/ErrorSet';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  isHexString,
  isInteger,
} from 'lorautils/checkers/numbers';
import callAPI from '@/api/callAPI';
import AddGateway from '../AddGateway';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
};

const EncodingOptions = [{
  name: 'HEX',
  value: 'hex',
  active: true,
}, {
  name: 'TEXT',
  value: 'text',
}];

class SendBroadcast extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: false,
      encoding: 'hex',
      gateway: [],
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'port')
          .add('FE_EMPTY', 'data')
          .add('FE_EMPTY', 'devaddr')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.broadcast');
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  checkPort(port) {
    const { errors } = this.state;

    if (_.isNil(port) || port === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'port') });
      return false;
    }

    if (!isInteger(port, { min: 1, max: 223 })) {
      this.setState({ errors: errors.add('FE_INVALIDPORT', 'port') });
      return false;
    }

    this.setState({ errors: errors.remove('port') });
    return true;
  }

  checkData(data, encoding) {
    const { errors } = this.state;

    if (_.isNil(data) || data === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'data') });
      return false;
    }

    if (encoding === 'hex') {
      if (!isHexString(data, { pair: true })) {
        this.setState({ errors: errors.add('FE_INVALIDHEX', 'data') });
        return false;
      }
    }

    this.setState({ errors: errors.remove('data') });
    return true;
  }

  handleChangePort(e) {
    const port = e.target.value.trim();
    this.setState({ port });
    this.checkPort(port);
  }

  handleChangeEncoding(encoding) {
    this.setState({ encoding });

    const { data } = this.state;
    this.checkData(data, encoding);
  }

  handleChangeData(e) {
    const data = e.target.value;
    this.setState({ data });

    const { encoding } = this.state;
    this.checkData(data, encoding);
  }

  handleChangeDevaddr(e) {
    const { errors } = this.state;
    let devaddr = _.trim(e.target.value);
    devaddr = devaddr.replace(/:|-/g, '');
    if (devaddr.length === 0) {
      this.setState({ errors: errors.add('FE_EMPTY', 'devaddr') });
    } else {
      this.setState({ errors: errors.remove('devaddr') });
    }
    this.setState({ devaddr });
  }

  handleOnChgGateway(gateway) {
    let gatewayLabels = '';
    if (gateway.length) {
      gatewayLabels = gateway.length === 1 ? gateway[0].id : `${gateway[0].id}...`;
    }
    this.setState({ gateway, showModal: false, gatewayLabels });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { data, devaddr, port, gateway, encoding } = this.state;
    let { errors } = this.state;
    this.setState({ submitted: true });
    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }
    this.setState({ sentStatus: 'pending' });
    const gws = _.map(gateway, gw => gw.id);
    callAPI({
      endpoint: `/lora/apps/${this.props.appId}/broadcastmsgs`,
      method: 'POST',
      body: {
        devaddr,
        gateways: gws,
        data,
        encoding,
        fport: Number(port),
      },
    }).then(() => {
      this.setState({ sentStatus: 'success' });
    }).catch((err) => {
      this.setState({ sentStatus: 'failure', errors: errors.add(err.code, 'submit') });
    });
  }

  render() {
    const {
      port = '',
      data = '',
      devaddr = '',
      submitted = false,
      errors,
      encoding,
      showModal = false,
      sentStatus = '',
      gateway = [],
      gatewayLabels = '',
    } = this.state;
    return (
      <div className={styles.fullHeight}>
        <Panel
          bsStyle="aisz-white"
          className={`${styles.fullHeight} ${styles.noMgnB}`}
          header={this.intlMsg.msg('send.header')}
        >
          <Form
            horizontal
            onSubmit={this.handleSubmit}
          >
            <FormGroup>
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('send.addr')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={devaddr}
                  bsClass="aisz-form-control-f"
                  placeholder={this.intlMsg.msg('send.addr.placeholder')}
                  onChange={e => this.handleChangeDevaddr(e)}
                />
                <ControlTips
                  show={errors.has('devaddr') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('devaddr'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('send.port')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={port}
                  bsClass="aisz-form-control-f"
                  placeholder={this.intlMsg.msg('send.port.placeholder')}
                  onChange={e => this.handleChangePort(e)}
                />
                <ControlTips
                  show={errors.has('port') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('port'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('send.encoding')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <SelectPills
                  options={EncodingOptions}
                  value={encoding}
                  onChange={selected => this.handleChangeEncoding(selected[0])}
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('send.data')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={data}
                  bsClass="aisz-form-control-f"
                  placeholder="Hex"
                  onChange={e => this.handleChangeData(e)}
                />
                <ControlTips
                  show={errors.has('data') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('data'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('send.gateway')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={gatewayLabels}
                  bsClass="aisz-form-control-f"
                  className={styles.black}
                  disabled
                />
              </Col>
              <Col md={2}>
                <Link
                  className={styles.add}
                  onClick={() => this.setState({ showModal: true })}
                >
                  <span className="glyphicon glyphicon-plus" />
                </Link>
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={9} mdOffset={3}>
                <RichButton
                  status={sentStatus}
                  states={[{
                    status: 'default',
                    label: (
                      <span>
                        <span className="halflings halflings-send" />{' '}
                        {this.intlMsg.msg('send')}
                      </span>
                    ),
                    type: 'submit',
                  }, {
                    status: 'pending',
                    style: 'info',
                    label: <span><i className="fa fa-spinner fa-spin" />{' '}{this.intlMsg.msg('sending')}</span>,
                  }, {
                    status: 'success',
                    style: 'success',
                    label: this.intlMsg.msg('sendsuccess'),
                    timer: () => this.setState({ sentStatus: '' }),
                  }, {
                    status: 'failure',
                    style: 'danger',
                    label: this.intlMsg.msg('sendfailure'),
                    timer: () => this.setState({ sentStatus: '' }),
                  }]}
                />
                <ShowIf if={sentStatus === 'failure'}>
                  <span className={styles.err}>
                    <i className="fa fa-exclamation-circle" />&nbsp;
                    {this.intlMsg.errorMsg(errors.get('submit'))}
                  </span>
                </ShowIf>
              </Col>
            </FormGroup>
          </Form>
        </Panel>
        <AddGateway
          showModal={showModal}
          onHide={() => this.setState({ showModal: false })}
          onSuccess={gw => this.handleOnChgGateway(gw)}
          checked={gateway}
        />
      </div>
    );
  }
}

SendBroadcast.propTypes = propTypes;

export default connect(
  null,
  null,
)(injectIntl(SendBroadcast));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/BroadcastView/coms/SendBroadcast/index.jsx